/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MeetingSectionTopicLink = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The MeetingSectionTopicLink model module.
   * @module model/MeetingSectionTopicLink
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MeetingSectionTopicLink</code>.
   * @alias module:model/MeetingSectionTopicLink
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>MeetingSectionTopicLink</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MeetingSectionTopicLink} obj Optional instance to populate.
   * @return {module:model/MeetingSectionTopicLink} The populated <code>MeetingSectionTopicLink</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('CreatedBy')) {
        obj['CreatedBy'] = ApiClient.convertToType(data['CreatedBy'], 'Integer');
      }
      if (data.hasOwnProperty('SectionTopicID')) {
        obj['SectionTopicID'] = ApiClient.convertToType(data['SectionTopicID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentTypeID')) {
        obj['ContentTypeID'] = ApiClient.convertToType(data['ContentTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentID')) {
        obj['ContentID'] = ApiClient.convertToType(data['ContentID'], 'Integer');
      }
      if (data.hasOwnProperty('ForwardText')) {
        obj['ForwardText'] = ApiClient.convertToType(data['ForwardText'], 'String');
      }
      if (data.hasOwnProperty('EmbeddedToMeetingSectionTopic')) {
        obj['EmbeddedToMeetingSectionTopic'] = ApiClient.convertToType(data['EmbeddedToMeetingSectionTopic'], 'Boolean');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} CreatedBy
   * @default 0
   */
  exports.prototype['CreatedBy'] = 0;
  /**
   * @member {Integer} SectionTopicID
   * @default 0
   */
  exports.prototype['SectionTopicID'] = 0;
  /**
   * @member {Integer} ContentTypeID
   * @default 0
   */
  exports.prototype['ContentTypeID'] = 0;
  /**
   * @member {Integer} ContentID
   * @default 0
   */
  exports.prototype['ContentID'] = 0;
  /**
   * @member {String} ForwardText
   * @default ''
   */
  exports.prototype['ForwardText'] = '';
  /**
   * @member {Boolean} EmbeddedToMeetingSectionTopic
   * @default false
   */
  exports.prototype['EmbeddedToMeetingSectionTopic'] = false;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


